<template>
  <!-- bottom nav bar in mobile mode -->
  <nav class="trending-nav">
    <router-link v-bind:to="{ name: 'home' }" class="trending-nav-search-button" v-on:click="sectionClicked = 'home'" aria-label="Home">
      <i v-bind:class="{ red: isSectionActive('home') }" class="fa-solid fa-home fa-lg"></i>
      <span class="visually-hidden">Home</span> <!-- Visually hidden text -->
    </router-link>
    <router-link v-bind:to="{ name: 'TrendingPage' }" class="trending-nav-search-button" v-on:click="sectionClicked = 'trending'" aria-label="Trending">
      <i v-bind:class="{ red: isSectionActive('TrendingPage') }" class="fa-solid fa-arrow-trend-up fa-lg"></i>
      <span class="visually-hidden">Trending</span> <!-- Visually hidden text -->
    </router-link>
    <MobileNotificationsBell></MobileNotificationsBell>
    <router-link v-bind:to="{ name: 'searchBar' }" class="trending-nav-search-button" v-on:click="sectionClicked = 'search'" aria-label="Search">
      <i v-bind:class="{ red: isSectionActive('searchBar') }" class="fa-solid fa-magnifying-glass fa-lg"></i>
      <span class="visually-hidden">Search</span> <!-- Visually hidden text -->
    </router-link>
  
    <router-link v-bind:to="{ name: 'profilePage' }" class="trending-nav-search-button" v-on:click="sectionClicked = 'profile'" aria-label="Profile">
      <i v-bind:class="{ red: isSectionActive('profilePage') }" class="fa-solid fa-user fa-lg"></i>
      <span class="visually-hidden">Profile</span> <!-- Visually hidden text -->
    </router-link>
  </nav>
</template>

<script>
import MobileNotificationsBell from './MobileNotificationsBell.vue'

export default {
  components: {
    MobileNotificationsBell
  },
  data() {
    return {
      sectionClicked: ''
    }
  },
  methods: {
    isSectionActive(sectionName) {
      console.log("route: " + this.$route.name)
      console.log("section: " + sectionName)
      return this.$route.name === sectionName;
    }
  }
}
</script>



<style scoped>

i {
  background: none;
    border: none;
    margin: 0;
    cursor: pointer;
    color: #0b7ee3;
}
.red{
  color: #dd3434;
}

a {
  text-decoration: none;
    color: black;
    transition: all 0.3s ease;
    font-family: 'Titillium Web', sans-serif;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 0.75em 0.5em;
    min-width: 44px;
    min-height: 44px;
}
button{
  background: none;
    border: none;
    margin: 2em;
    cursor: pointer;
}

.i-changed {
    color: #dd3434;
    background-color: rgba(221, 52, 52, 0.1);  
  border-radius: 8px;
}

.hidden{
    display: none;
}

.trending-nav{
    display: flex;
    justify-content: space-around;
    border-top: 2px solid #0b7ee3;
    background-color: #fff;
    z-index: 1100 !important;
    position: fixed;
    bottom: 0;
    left: 0; 
    right: 0;
    width: 100%;
    
    padding: 0.5em 0;
    padding-bottom: max(0.5em, env(safe-area-inset-bottom));
}

/* SEO  */
.visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}

@media (min-width: 100px) and (max-width: 913px) {
    .trending-nav {
        display: flex !important;
        background-color: #fff;
        z-index: 1100 !important;
        position: fixed !important;
        bottom: 0;
        width: 100%;
}
}

@media (min-width: 914px) {
    .trending-nav {
        display: none !important;
    }
}

</style>